
    <div class="carousel__container">
        <ngb-carousel [showNavigationArrows]="false">
            <ng-template ngbSlide *ngFor="let slide of slider" >
                <div class="picsum-img-wrapper">
                    <img [src]="slide" alt="Random first slide" class="animated fadeIn d-block img-fluid"/>
                </div>
            </ng-template>
        </ngb-carousel>
    </div>